<template>
  <div>
    <div class="send-box">
      <p class="title"><i class="el-icon-success"></i>您的邮件已发送！</p>
      <p class="tip">此邮件发送成功，并以保存到"已发送"文件夹。</p>
      <el-button size="mini" type="primary" @click="$router.replace('/homepage')">返回邮箱首页</el-button>
      <el-button size="mini" @click="goToEmail">再写一封</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tip",
  data() {
    return {};
  },
  methods: {
    goToEmail() {
      this.$router.push({
        path: "/email",
        query: {
          type: 0,
        },
      });
    },
  },
};
</script>
<style lang="scss">
.send-box {
  padding: 50px;
  line-height: 30px;
  .title {
    font-size: 20px;
    color: #53961a;
  }
  .tip {
    font-size: 12px;
    color: #ccc;
  }
}
</style>
